<template>
<div>
  <div class="elements-container row" v-if="elements.length > 0">
    <div
      v-for="element in elements"
      :key="element.id"
      :class="`${
        displayImage(element) ? 'col-6' : 'col-12'
      } element-container`"
      :style="getDynamicPageBg(element)"
    >
      <div class="container">
        <custom-view-section :element="element" :quick-link-list="quickLinkList"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import mixin from '@/utils/mixin.js'
import CustomViewSection from '@/components/Dynamic/CustomViewSection.vue'

export default {
  name: 'CustomStaticDynamicPage',
  props: ['newContents'],
  components: {
    CustomViewSection
  },
  mixins: [mixin],
  data() {
    return {
      elements: this.newContents || [],
      quickLinkList: []
    }
  },
  methods: {
    displayImage(element) {
      if(element.order > 1 && element.order > this.elements.length) {
        return (
          (element.field_type === 'image' && element.field_type !== 'string') ||
          (element.order % 2 !== 0 &&
            this.nextElement(element.order)?.field_type === 'image') ||
          (element.order % 2 === 0 &&
            this.previousElement(element.order)?.field_type === 'image')
        )
      }
    },
    previousElement(order) {
      return this.elements.find((element) => element.order === order - 1)
    },
    nextElement(order) {
      return this.elements.find((element) => element.order === order + 1)
    },
    findElement(id) {
      return this.elements.find((element) => element.id === id)
    }
  },
}
</script>

<style lang="scss" scoped>
.row {
  display: block !important;
}
.elements-container {
  .element-container {
    text-align: justify;
    word-wrap: break-word;
    display: flex;
    align-items: center;
    //justify-content: center;
  }
}
</style>
